<div class="upload-dialog">
  @if (isUploading) {
    <div class="progress-bar-container">
      <svg>
        <circle cx="50" cy="50" r="50"></circle>
        <circle [style]="getProgressStyle(progress)" cx="50" cy="50" r="50"></circle>
      </svg>
      <span class="progress-bar-counter">
        {{ progress }}%
      </span>
    </div>
    <p>{{ createLabel(files.length, 'Загружен|Загружено|Загружено', false) }} файлов {{ files.length }} из {{ uploader.queue.length }} </p>

  } @else if (!finished) {
    <label class="loader" (onFileDrop)="upload()" [uploader]="uploader" ng2FileDrop>
      <nb-icon icon="cloud-upload-outline" style="font-size: 50px"/>

      <h4>Загрузить файлы </h4><br>
      <p>Нажмите, чтобы загрузить файл, либо перетащите сюда</p>
      <p>Разрешен любой формат файлов размером до 4 ГБ</p>

      <input ng2FileSelect (change)="upload()" [uploader]="uploader" class="files-input" type="file" multiple> </label>

  } @else {
    <p>Загрузка завершена. {{ createLabel(files.length, 'Загружен|Загружено|Загружено', false) }} {{ createLabel(files.length, 'файл|файла|файлов') }} </p>

    <button nbButton (click)="restart()">
      <nb-icon icon="repeat-outline"/>
      Загрузить еще файл
    </button>
  }
</div>
